import type { JSX } from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@frontend/components/atoms/AlertDialog";
import { Trans } from "@lingui/react/macro";

import type { DiscardChangesDialogProps } from "../types";

export function DiscardChangesDialog({
  open,
  onKeep,
  onDiscard,
}: DiscardChangesDialogProps): JSX.Element {
  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) {
          onKeep();
        }
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            <Trans>Discard the changes?</Trans>
          </AlertDialogTitle>

          <AlertDialogDescription>
            <Trans>
              What you changed here has not been saved. Closing now loses it.
            </Trans>
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogCancel>
            <Trans>Keep editing</Trans>
          </AlertDialogCancel>

          <AlertDialogAction variant="destructive" onClick={onDiscard}>
            <Trans>Discard</Trans>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
